module.exports = __webpack_public_path__ + "static/media/rightmenuimage.06620534.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rightmenuimage.png
// module id = 141
// module chunks = 0